import { type MouseEvent, type ReactNode, useState } from 'react';
import {
  Popover as MuiPopover,
  type PopoverProps as MuiPopoverProps,
} from '@mui/material';

type PopoverProps = Omit<MuiPopoverProps, 'open' | 'anchorEl' | 'onClose'> & {
  trigger: (props: { onClick: (event: MouseEvent<HTMLElement>) => void }) => ReactNode;
};

export const Popover = (props: PopoverProps) => {
  const {
    trigger,
    children,
    anchorOrigin = { vertical: 'bottom', horizontal: 'left' },
    transformOrigin = { vertical: 'top', horizontal: 'left' },
    ...popoverProps
  } = props;

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {trigger({ onClick: handleOpen })}
      <MuiPopover
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        {...popoverProps}
      >
        {children}
      </MuiPopover>
    </>
  );
};
